import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashboardCard from "../../components/DashboardCard/DashboardCard";
import userIcon from "../../../src/assets/user.png";
import userIconTick from "../../../src/assets/user-tick.png";
import userIconWrong from "../../../src/assets/user-wrong.png";
import car from "../../../src/assets/car.png";
import userBlack from "../../../src/assets/userBlack.png";
import cardAdd from "../../../src/assets/card-add.png";
import total from "../../../src/assets/totalPaketa.png";
import cardPos from "../../../src/assets/card-pos.png";
import a from "../../../src/assets/A.png";
import b from "../../../src/assets/B.png";
import c from "../../../src/assets/C.png";
import c1 from "../../../src/assets/C1.png";
import d from "../../../src/assets/D.png";
import {
  getTotalDataCount,
  fetchOnlineUsersCount,
} from "../../store/slices/apiDrivingSchoolsSlice";

const Dashboard = () => {
  const dispatch = useDispatch();
  const totalData = useSelector((state) => state.apiDrivingSchools.totalData);
  const totalOnlineUsers = useSelector(
    (state) => state.apiDrivingSchools.totalOnlineUsers
  );
  useEffect(() => {
    dispatch(getTotalDataCount());
    dispatch(fetchOnlineUsersCount());
  }, [dispatch]);

  const cards = [
    {
      title: "Numri i kandidatëve që janë aktualisht online",
      value: totalOnlineUsers?.count ?? 0,
      image: userIcon,
    },
    {
      title: "Numri i kandidatëve që kanë abonime aktive momentalisht",
      value: totalData?.details?.findActiveSubscriptions,
      image: userIconTick,
    },
    {
      title: "Numri i kandidatëve me abonime te skaduara",
      value: totalData?.details?.findUnActiveSubscriptions,
      image: userIconWrong,
    },
    {
      title: "Totali i Autoshkollave",
      value: totalData?.details?.getAllSchools,
      image: car,
    },
    {
      title: "Totali i Kandidatëve",
      value: totalData?.details?.findAllUsers,
      image: userBlack,
    },
    {
      title: "Totali i aktivizimit të paketave",
      value: totalData?.details?.getActivatedCards,
      image: total,
    },
    {
      title: "Totali i aktivizimit direkt nga banka",
      value: totalData?.details?.getAllBankPayments,
      image: cardAdd,
    },
    {
      title: "Totali i aktivizimeve me para në dorë në autoshkollë",
      value: totalData?.details?.getAllCashPayments,
      image: cardAdd,
    },
    {
      title: "Totali i aktivizimeve përmes kartelave fizike",
      value: totalData?.details?.getActivatedCards,
      image: cardPos,
    },
    {
      title: "Numri i aktivizimeve për kategorinë B",
      value: totalData?.details?.getActivateCategoriesForCategoryB.totalCount,
      image: b,
    },
    {
      title: "Numri i aktivizimeve për kategorinë B - aktive",
      value:
        totalData?.details?.getActivateCategoriesForCategoryB
          .currentlyActiveCount,
      image: b,
    },
    {
      title: "Numri i aktivizimeve për kategorinë A",
      value: totalData?.details?.getActivateCategoriesForCategoryA.totalCount,
      image: a,
    },
    {
      title: "Numri i aktivizimeve për kategorinë A - aktive",
      value:
        totalData?.details?.getActivateCategoriesForCategoryA
          .currentlyActiveCount,
      image: a,
    },
    {
      title: "Numri i aktivizimeve për kategorinë C1",
      value: totalData?.details?.getActivateCategoriesForCategoryC1.totalCount,
      image: c1,
    },
    {
      title: "Numri i aktivizimeve për kategorinë C1 - aktive",
      value:
        totalData?.details?.getActivateCategoriesForCategoryC1
          .currentlyActiveCount,
      image: c1,
    },
    {
      title: "Numri i aktivizimeve për kategorinë C",
      value: totalData?.details?.getActivateCategoriesForCategoryC.totalCount,
      image: c,
    },
    {
      title: "Numri i aktivizimeve për kategorinë C - aktive",
      value:
        totalData?.details?.getActivateCategoriesForCategoryC
          .currentlyActiveCount,
      image: c,
    },
    {
      title: "Numri i aktivizimeve për kategorinë D",
      value: totalData?.details?.getActivateCategoriesForCategoryD.totalCount,
      image: d,
    },
    {
      title: "Numri i aktivizimeve për kategorinë D - aktive",
      value:
        totalData?.details?.getActivateCategoriesForCategoryD
          .currentlyActiveCount,
      image: d,
    },
  ];

  return (
    <div className="mt-24">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {cards.map((card, index) => (
          <DashboardCard
            key={index}
            title={card.title}
            value={card.value}
            image={card.image}
          />
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
